<template>
    <div class="toolbar toolbar-texture">
        <div>
            <span class="text-uppercase">{{ __('Szín') }}:</span>
            <span class="button-tooltip">{{ product.color.name }}</span>
            <span
                v-if="product.color.name2"
                class="button-tooltip"
            >
                 - {{ product.color.name2 }}
            </span>
            <span
                v-if="product.patternName"
                class="button-tooltip"
            >
                 - {{ product.patternName }}
            </span>
        </div>
        <div v-for="variant in variants"
             class="button"
             :data-tooltip="variant.color.name"
             :class="{'selected': product.color.id === variant.color.id }"
             style="width: 57px; height: 77px;"
             @click="$emit('update:product', variant);">
            <label>
                <responsive-image
                    v-if="variant.variantImage"
                    :media="variant.variantImage"
                    :alt="variant.color.name"
                    classes="color-image"
                    width="50"
                    height="80"
                    style="margin-top: -3px;"
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VariantsPicker',

    props: {
        product: {
            type: Object,
        },

        variants: {
            type: Array
        }
    }
}
</script>

<style scoped>

</style>
